import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

const handleChunkError = () => {
  const lastReload = parseInt(sessionStorage.getItem('chunk-error-reload') || '0', 10)
  const now = Date.now()
  // Only reload if the last reload was more than 10 seconds ago to prevent infinite reload loops
  if (now - lastReload > 10000) {
    sessionStorage.setItem('chunk-error-reload', now.toString())
    window.location.reload()
  } else {
    console.error('Chunk loading failed repeatedly, stopping reload loop.')
  }
}

window.addEventListener('vite:preloadError', () => {
  handleChunkError()
})

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason as { message?: string } | undefined
  const message: string = reason?.message || ''
  if (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Expected a JavaScript-or-Wasm module script') ||
    message.includes('Importing a module script failed') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('blocked because of a disallowed MIME type')
  ) {
    handleChunkError()
  }
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
